import React, { useEffect, useCallback, useState} from 'react';
import Dropdown from 'react-dropdown';
import {connect} from 'react-redux';

const TrackRules = ({parameter, value}) => { 
    let options = new Array(5).fill(0).map(
        (rule, i) => ({label: i+1, value: i})).slice(1);


    const onChange = useCallback(({value}) => {
        parameter.set(value);
    }, [parameter]);

    let opt = options.find(x => x.value === value);
    options = [{label: "None", value: null}, ... options];

    return (
        <div onMouseDown={e => e.stopPropagation()} className="track-shift track-rules">
              <Dropdown
                placeholder=""
                options={options}
                value={opt}
                onChange={onChange}
        />
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      value: props.parameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackRules);
